import { render } from "./BoutiqueComponent.vue?vue&type=template&id=b14b9bfa"
import script from "./BoutiqueComponent.vue?vue&type=script&lang=js"
export * from "./BoutiqueComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__